import { render } from "./modifyPassword.vue?vue&type=template&id=37211bf1&scoped=true"
import script from "./modifyPassword.vue?vue&type=script&lang=js"
export * from "./modifyPassword.vue?vue&type=script&lang=js"

import "./modifyPassword.vue?vue&type=style&index=0&id=37211bf1&lang=less&scoped=scoped"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37211bf1"]])

export default __exports__